<template>
  <OurGroups>
    <OurGroup>
      <OurMultiselect
        v-model="form.customers"
        :options="customers"
        :label="$t('label.customers')"
        :placeholder="$t('placeholder.selectCustomers')"
      >
        <template #after-label>
          <OurTag
            class="ml-1 !p-0"
            color="transparent"
            text=""
            tooltip-text="Оберіть дилерів, користувачам якиx буде доступна функціональність. Щоб вона була доступна усім - просто залиште це поле пустим"
          />
        </template>
      </OurMultiselect>
      <OurSelect
        v-model="form.isActive"
        :options="statuses"
        :label="$t('label.status')"
        :placeholder="$t('placeholder.selectStatus')"
        item-label="text"
        value-key="value"
        :allow-empty="false"
      >
        <template #after-label>
          <OurTag
            class="ml-1 !p-0"
            color="transparent"
            text=""
            tooltip-text="Керуйте відображенням функціональності на сайті"
          />
        </template>
      </OurSelect>
    </OurGroup>
  </OurGroups>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "FeatureForm",

  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      form: {
        customers: [],
        isActive: true,
      },
      statuses: [
        {
          text: this.$t("focusGroup.isActive.activated"),
          value: true,
        },
        {
          text: this.$t("focusGroup.isActive.deactivated"),
          value: false,
        },
      ],
    };
  },

  computed: {
    ...mapState("focusGroup", ["customers"]),
  },

  watch: {
    value: {
      handler: "getForm",
      deep: true,
    },
  },

  created() {
    this.getForm();
  },

  methods: {
    getForm() {
      if (this.value) {
        this.form = { ...this.value };
      }
    },

    emitForm() {
      this.$emit("input", this.form);
    },
  },
};
</script>
